import React from "react"

export const Location = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <mask id="path-1-inside-1" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9693 23.0167C11.8124 23.0166 11.6665 22.9321 11.5836 22.7931C10.7663 21.423
          9.63678 19.9875 8.54444 18.5993L8.54429 18.5992C7.82093 17.6799 7.07293 16.7293
          6.41331 15.796C5.28971 14.2062 4 12.1142 4 10.0313C4 5.42824 7.58807 1.68335
          11.9984 1.68335C16.4105 1.68335 20 5.42824 20 10.0313C20 12.2634 18.6304
          14.4853 16.5739 17.1349C16.2145 17.598 15.839 18.0691 15.4756 18.5249L15.4711
          18.5305L15.47 18.5319L15.47 18.5319C14.3525 19.9338 13.197 21.3832 12.3549
          22.7934C12.2719 22.9322 12.1261 23.0167 11.9693 23.0167ZM12.0009 12.0166C10.3462
          12.0166 9 10.6704 9 9.01572C9 7.36198 10.3462 6.0166 12.0009 6.0166C13.6546
          6.0166 15 7.36201 15 9.01572C15 10.6704 13.6546 12.0166 12.0009 12.0166Z"
        />
      </mask>
      <path
        d="M11.5836 22.7931L12.9577 21.9735L12.9577 21.9734L11.5836 22.7931ZM11.9693
        23.0167L11.9688 24.6167H11.9693V23.0167ZM8.54444 18.5993L7.28199 19.5823L7.28705
        19.5888L8.54444 18.5993ZM8.54429 18.5992L9.80674 17.6162L9.8017 17.6097L8.54429
        18.5992ZM6.41331 15.796L5.1067 16.7194L5.10671 16.7195L6.41331 15.796ZM16.5739
        17.1349L15.31 16.1538L15.3099 16.1539L16.5739 17.1349ZM15.4756 18.5249L16.7267
        19.5223L16.7267 19.5222L15.4756 18.5249ZM15.4711 18.5305L16.7208 19.5297L16.7222
        19.5279L15.4711 18.5305ZM15.47 18.5319L16.7194 19.5314L16.7197 19.5311L15.47
        18.5319ZM15.47 18.5319L14.2206 17.5324L14.2189 17.5346L15.47 18.5319ZM12.3549
        22.7934L13.7282 23.6144L13.7286 23.6137L12.3549 22.7934ZM10.2094 23.6126C10.57
        24.2173 11.2276 24.6164 11.9688 24.6167L11.9697 21.4167C12.3971 21.4168 12.763
        21.647 12.9577 21.9735L10.2094 23.6126ZM7.28705 19.5888C8.39601 20.9981 9.45543
        22.3486 10.2094 23.6127L12.9577 21.9734C12.0772 20.4973 10.8776 18.977 9.80183
        17.6099L7.28705 19.5888ZM7.28186 19.5821L7.282 19.5823L9.80687 17.6164L9.80673
        17.6162L7.28186 19.5821ZM5.10671 16.7195C5.79431 17.6923 6.56864 18.6758 7.28689
        19.5886L9.8017 17.6097C9.07321 16.6839 8.35156 15.7662 7.71991 14.8725L5.10671
        16.7195ZM2.4 10.0313C2.4 12.6793 3.99912 15.1523 5.1067 16.7194L7.71993 14.8725C6.5803
        13.26 5.6 11.5491 5.6 10.0313H2.4ZM11.9984 0.0833496C6.6406 0.0833496 2.4 4.60978 2.4
        10.0313H5.6C5.6 6.2467 8.53555 3.28335 11.9984 3.28335V0.0833496ZM21.6 10.0313C21.6
        4.60917 17.3574 0.0833496 11.9984 0.0833496V3.28335C15.4636 3.28335 18.4 6.24732 18.4
        10.0313H21.6ZM17.8379 18.1159C19.87 15.4976 21.6 12.8754 21.6 10.0313H18.4C18.4
        11.6514 17.3907 13.473 15.31 16.1538L17.8379 18.1159ZM16.7267 19.5222C17.0889
        19.0679 17.471 18.5886 17.8379 18.1158L15.3099 16.1539C14.958 16.6073 14.589
        17.0702 14.2245 17.5275L16.7267 19.5222ZM16.7222 19.5279L16.7267 19.5223L14.2246
        17.5274L14.2201 17.5331L16.7222 19.5279ZM16.7197 19.5311L16.7208 19.5297L14.2215
        17.5313L14.2204 17.5327L16.7197 19.5311ZM16.7194 19.5314L16.7194 19.5314L14.2206 17.5324L14.2206
        17.5324L16.7194 19.5314ZM13.7286 23.6137C14.5047 22.314 15.5868 20.9522 16.7211 19.5293L14.2189
        17.5346C13.1182 18.9153 11.8893 20.4524 10.9812 21.973L13.7286 23.6137ZM11.9693 24.6167C12.7109
        24.6167 13.3677 24.2173 13.7282 23.6144L10.9816 21.9723C11.176 21.6471 11.5413 21.4167 11.9693
        21.4167V24.6167ZM7.4 9.01572C7.4 11.5541 9.46258 13.6166 12.0009 13.6166V10.4166C11.2298
        10.4166 10.6 9.78673 10.6 9.01572H7.4ZM12.0009 4.4166C9.46343 4.4166 7.4 6.47742 7.4 9.01572H10.6C10.6
        8.24654 11.2289 7.6166 12.0009 7.6166V4.4166ZM16.6 9.01572C16.6 6.47837 14.5383 4.4166 12.0009
        4.4166V7.6166C12.7709 7.6166 13.4 8.24565 13.4 9.01572H16.6ZM12.0009 13.6166C14.5392 13.6166 16.6
        11.5532 16.6 9.01572H13.4C13.4 9.78766 12.7701 10.4166 12.0009 10.4166V13.6166Z"
        fill="#0374D6"
        mask="url(#path-1-inside-1)"
      />
    </svg>
  )
}
